module.exports = __webpack_public_path__ + "static/media/lg.f4292655.ttf";